export default { 
    "base_url": "",
    "api_base_url": "http://eg-pshield-dev.azurewebsites.net", 
    "application_key":  "NV0L6L-QI4YW4-EPF0UK-W0DYVV-3B70K"
}